import { createContext, useContext } from 'react';
import type { PageContextType } from '../../types';

export const PageContext = createContext<PageContextType | undefined>(
  undefined
);

export function usePageContext(): PageContextType {
  const context = useContext(PageContext);

  if (!context) {
    throw new Error('usePageContext must be used within a PageContextProvider');
  }

  return context;
}
